import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: 'Relinex Home'
          }
        }, {
          path: '/Products',
          name: 'Products',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: 'Products'
          },
          children: [
            {
              path: '/Products',
              redirect: '/Products/Filler'
            },
            {
              path: '/Products/Filler',
              name: 'Filler',
              component: resolve => require(['@/view/Products_Filler'], resolve),
              meta: {
                title: 'Filler'
              }
            },
            {
              path: '/Products/Skinbooster',
              name: 'Skin booster',
              component: resolve => require(['@/view/Products_Skinbooster'], resolve),
              meta: {
                title: 'Skin booster'
              }
            }
          ]
        },{
          path: '/product/Lemon',
          name: 'lemon',
          component: resolve => require(['@/view/Product-Lemon'], resolve),
          meta: {
            title: 'Lemon'
          }
        },{
          path: '/product/Neuramis',
          name: 'Neuramis',
          component: resolve => require(['@/view/Product-Neuramis'], resolve),
          meta: {
            title: 'Neuramis'
          }
        },{
          path: '/product/Rejeunesse',
          name: 'Rejeunesse',
          component: resolve => require(['@/view/Product-Rejeunesse'], resolve),
          meta: {
            title: 'Rejeunesse'
          }
        },{
          path: '/product/profhilo',
          name: 'profhilo',
          component: resolve => require(['@/view/Product-profhilo'], resolve),
          meta: {
            title: 'Profhilo'
          }
        },{
          path: '/product/Revolax',
          name: 'Revolax',
          component: resolve => require(['@/view/Product-Revolax'], resolve),
          meta: {
            title: 'Revolax'
          }
        },{
          path: '/product/Sculptra',
          name: 'Sculptra',
          component: resolve => require(['@/view/Product-Sculptra'], resolve),
          meta: {
            title: 'Sculptra'
          }
        },
        , {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: 'Relinex Projects'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: 'Relinex news'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: 'About us'
          }
        },{
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: 'Contact us'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: 'Global Markets Collaboration'
          }
        },{
          path: '/thank-you',
          name: 'thanku',
          component: resolve => require(['@/view/ThankYouPage'], resolve),
          meta: {
            title: 'Thank u'
          }
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js